export default __webpack_public_path__ + "static/media/strategy-goals-icon.4cf54913.svg";